import commonService from "./common-service";

class AmountService {
  async getAmountPerProfile() {
    try {
      const response = await commonService.getFromServer(
        "EOM/AmountDuePerProfile",
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async createProfile(params) {
    try {
      let response = await commonService.postToServer(
        "EOM/AmountDuePerProfile",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async updateProfile(params) {
    try {
      let response = await commonService.updateToServer(
        "EOM/AmountDuePerProfile/" + params.id,
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getProfile(id) {
    try {
      const response = await commonService.getFromServer(
        "EOM/AmountDuePerProfile/" + id,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.msg.error);
    }
  }

  async deleteProfile(id) {
    try {
      const response = await commonService.deleteToServer(
        "EOM/AmountDuePerProfile/" + id,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error deleting profile");
      }
    } catch (e) {
      throw new Error("Error deleting profile");
    }
  }
}

export default new AmountService();
